import $ from "jquery";
import { App } from "../App";

import "./Impressum.less";

export class Impressum {
    constructor() {
        new App();

        $(".smb-impressum").toggleClass("smb-hide", false);
    }
}

$((): void => {
    if ($(".smb-impressum").length > 0) {
        new Impressum();
    }
});